export enum ExportPaymentKey {
  Id = 'id',
  SubscriptionRequestNumber = 'subscriptionRequestNumber',
  SubscriptionRequestStatus = 'subscriptionRequestStatus',
  SubscriptionTypeName = 'subscriptionTypeName',
  User = 'user',
  CreatedAt = 'createdAt',
  PaymentMethod = 'paymentMethod',
  Type = 'type',
  PaidAmount = 'paidAmount',
  BankDomiciliation = 'bankDomiciliation',
  CheckNumber = 'checkNumber',
  PaymentConfig = 'paymentConfig',
  CtxContracts = 'ctxContracts',
}
